import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

// Import slices
import productsReducer from './slices/productsSlice';
import analysesReducer from './slices/analysesSlice';
import dashboardReducer from './slices/dashboardSlice';

// Configure store
export const store = configureStore({
  reducer: {
    products: productsReducer,
    analyses: analysesReducer,
    dashboard: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'analyses/exportAnalysis/fulfilled',
          'dashboard/exportDashboardData/fulfilled',
        ],
        // Ignore these field paths in all actions
        ignoredActionsPaths: ['payload.blob'],
        // Ignore these paths in the state
        ignoredPaths: ['payload.blob'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Export store as default
export default store;